import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "documents-component",
  "data-cy": "profile-view-documents"
}
const _hoisted_2 = {
  key: 0,
  class: "left"
}
const _hoisted_3 = {
  "data-cy": "profile-view-data-privacy",
  class: "data-privacy-message"
}
const _hoisted_4 = {
  key: 1,
  class: "left"
}
const _hoisted_5 = { class: "right" }
const _hoisted_6 = {
  key: 0,
  "data-cy": "profile-view-download-cv",
  class: "info-box",
  style: {"cursor":"pointer"}
}
const _hoisted_7 = ["src"]
const _hoisted_8 = { "data-cy": "cv-file-name" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "info-box" }
const _hoisted_11 = {
  key: 1,
  class: "box"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 1,
  class: "info-box"
}
const _hoisted_14 = ["src"]
const _hoisted_15 = { "data-cy": "cv-file-name" }
const _hoisted_16 = {
  key: 2,
  class: "info-box"
}
const _hoisted_17 = {
  key: 3,
  class: "p-error"
}
const _hoisted_18 = {
  key: 4,
  "data-cy": "profile-edit-upload-success"
}
const _hoisted_19 = {
  key: 2,
  "data-cy": "data-privacy",
  class: "data-privacy-message"
}
const _hoisted_20 = {
  key: 3,
  class: "call-to-action mobile-bottom-nav"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-left" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-right p-ml-1" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-right" }, null, -1)

import { computed, getCurrentInstance, ref, } from "vue";
    import { CandidateProfile } from "@/models/CandidateProfile";
    import { EncCandidateProfile } from "@/models/EncCandidateProfile";
    import { BrandId } from "@/models/BrandIds";
    import ProgressBar from "primevue/progressbar";
    import FileUpload from "primevue/fileupload";
    import { useToast } from "primevue/usetoast";
    import { createProfileService } from "@/services/profileService";
    import { createSignupService } from "@/services/signupService";
    import { CloudUploadIcon, InformationCircleIcon } from '@heroicons/vue/solid';
    import { useI18n } from "vue-i18n";

    
export default /*#__PURE__*/_defineComponent({
  __name: 'Documents',
  props: {
    isViewing: { type: Boolean },
    isProfileView: { type: Boolean },
    candidate: {},
    showButtons: { type: Boolean },
    disableValidation: { type: Boolean },
    isDirectSignUp: { type: Boolean },
    currentBrandId: {},
    hideConsent: { type: Boolean },
    showCvIsMandatoryMessage: { type: Boolean }
  },
  emits: ["cvUploaded", "submit", "previous"],
  setup(__props: any, { emit: __emit }) {

    const emit = __emit;
    const props = __props;

    const editableCandidate = ref(props.candidate);
    const app = getCurrentInstance();
    const { t } = useI18n();
    const toaster = useToast();

    const hasCV = computed(() => {
        if (editableCandidate.value?.latestCV) {
            return true;
        }
        return false;
    });

    const latestCV = computed(() => {
        return editableCandidate.value.latestCV;
    });

    const cvIcon = ref("");

    const getCvIcon = (filename) => {
        if (filename) {
            if (filename.indexOf(".pdf") > -1) {
                return "/kandidaten/img/pdf.svg";
            } else if (filename.indexOf(".doc") > -1) {
                return "/kandidaten/img/doc.svg";
            } else if (filename.indexOf(".docx") > -1) {
                return "/kandidaten/img/docx.svg";
            } else {
                return "";
            }
        }
        return "";
    }

    const isUploading = ref<Boolean>(false);
    const uploadProgress = ref();

    const uploadLabel = computed(() => {
        return isUploading.value ? "Processing" : t("documents.headline10");
    });

    const uploadUrl = ref("/kandidaten/profile/cv/" + props.candidate.id);
    const uploadSuccess = ref(false);
    const cvIsMandatoryMessage = ref(false);

    const onSuccessfulUpload = async () => {
        await resetUpload();
        toaster.add({
            severity: "success",
            summary: t("documents.headline9"),
            detail: "",
            life: 3000,
        });
        uploadSuccess.value = true;
        cvIsMandatoryMessage.value = false;
        hasCV.value = true;
        emit("cvUploaded");
    };

    const onFailedUpload = async () => {
        await resetUpload();
        toaster.add({
            severity: "error",
            summary: t("documents.upload.error"),
            detail: "",
            life: 3000,
        });
    };

    const resetUpload = async () => {
        isUploading.value = false;
        uploadProgress.value = 0;
    };

    const handleUploadProgress = async (event) => {
        uploadProgress.value = event.progress;
    };

    const submitted = ref(false);
    const uploadHandler = async (event) => {
        submitted.value = true;
        isUploading.value = true;
        const service = props.isDirectSignUp ? await createSignupService() : await createProfileService(app);
        let id = props.isDirectSignUp ? editableCandidate.value.encryptedId : editableCandidate.value.id;
        const result = await service.postCV(
            event.files[0],
            id,
            (event) =>
            (uploadProgress.value = Math.min(
                Math.ceil((event.loaded / event.total) * 100),
                100
            ))
        );
        cvIcon.value = getCvIcon(event.files[0].name);
        isUploading.value = false;
        if (result) {
            await onSuccessfulUpload();
        } else {
            await onFailedUpload();
        }
    };

    const displayFriendlyFileName = computed(() => {
        try {
            return `${editableCandidate.value.lastName}${editableCandidate.value.firstName}_CV`
        } catch (error) {
            return latestCV.value.fileName;
        }
    });

    const downloadCV = async () => {

        const service = await createProfileService(app);
        const split = latestCV.value.fileName.split(".");

        if (!split || split.length < 2) {
            throw new Error(t("documents.file.name.extension.error"));
        }

        const name = displayFriendlyFileName.value != "" ? displayFriendlyFileName.value : split[0];

        await service.downloadCv(name, split[1]);



    };

    const next = (emitVal) => {
        if (uploadSuccess.value || props.disableValidation) {
            emit(emitVal, editableCandidate.value);
            cvIsMandatoryMessage.value = false;
        } else {
            cvIsMandatoryMessage.value = true;
        }
    };

    const prev = () => {
        emit("previous", editableCandidate.value);
    };

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isProfileView)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(InformationCircleIcon), { class: "hero-icon" }),
            _createTextVNode(" " + _toDisplayString(_unref(t)("documents.headline8")), 1)
          ])
        ]))
      : (!_ctx.hideConsent && (!_ctx.isDirectSignUp || _ctx.candidate.brandId === _unref(BrandId).BigFour))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("h5", null, _toDisplayString(_unref(t)("documents.headline")), 1)
          ]))
        : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.isViewing)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "box",
            onClick: downloadCV
          }, [
            (hasCV.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("img", { src: cvIcon.value }, null, 8, _hoisted_7),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(displayFriendlyFileName.value), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(t)("documents.headline2")), 1),
                  _createVNode(_component_Button, {
                    "data-cy": "upload-cv",
                    class: "fake-upload-button button-disabled"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)("documents.headline3")), 1),
                      _createVNode(_unref(CloudUploadIcon))
                    ]),
                    _: 1
                  })
                ]))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_11, [
            (isUploading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createVNode(_unref(ProgressBar), {
                    mode: "determinate",
                    value: uploadProgress.value
                  }, null, 8, ["value"])
                ]))
              : (!isUploading.value && hasCV.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("img", { src: cvIcon.value }, null, 8, _hoisted_14),
                    _createElementVNode("span", _hoisted_15, _toDisplayString(displayFriendlyFileName.value), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_unref(t)("documents.headline4")), 1)),
            _createVNode(_unref(FileUpload), {
              auto: true,
              mode: "basic",
              name: "cv",
              "data-cy": "fileupload-choose",
              url: uploadUrl.value,
              onProgress: _cache[0] || (_cache[0] = ($event: any) => (handleUploadProgress($event))),
              onBeforeUpload: _cache[1] || (_cache[1] = ($event: any) => (isUploading.value = true)),
              onUpload: _cache[2] || (_cache[2] = ($event: any) => (onSuccessfulUpload())),
              onError: _cache[3] || (_cache[3] = ($event: any) => (onFailedUpload())),
              customUpload: true,
              onUploader: _cache[4] || (_cache[4] = ($event: any) => (uploadHandler($event))),
              multiple: false,
              accept: ".pdf, .doc, .docx",
              maxFileSize: 20000000,
              chooseLabel: uploadLabel.value
            }, {
              empty: _withCtx(() => [
                _createElementVNode("p", null, _toDisplayString(_unref(t)("documents.headline6")), 1)
              ]),
              _: 1
            }, 8, ["url", "chooseLabel"]),
            (cvIsMandatoryMessage.value || props.showCvIsMandatoryMessage)
              ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(_unref(t)("documents.headline7")), 1))
              : _createCommentVNode("", true),
            (uploadSuccess.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(_unref(t)("documents.headline5")), 1))
              : _createCommentVNode("", true)
          ])),
      (!_ctx.hideConsent && !_ctx.isProfileView)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_unref(t)("documents.headline8")), 1))
        : _createCommentVNode("", true),
      (_ctx.showButtons)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _createVNode(_component_Button, {
              "data-cy": "button-profile-prev",
              class: "button-secondary button-back p-pl-3",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (prev()))
            }, {
              default: _withCtx(() => [
                _hoisted_21,
                _createTextVNode(_toDisplayString(_unref(t)("back")), 1)
              ]),
              _: 1
            }),
            (_ctx.currentBrandId === _unref(BrandId).BigFour)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  "data-cy": "button-profile-next",
                  class: "button-primary button-next p-pr-3",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (next('submit')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString((_ctx.isDirectSignUp ? _unref(t)("continue") : _unref(t)("submit"))) + " ", 1),
                    _hoisted_22
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_Button, {
                  key: 1,
                  "data-cy": "button-profile-next",
                  class: "button-rectangle button-primary button-next",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (next('next')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("continue")) + " ", 1),
                    _hoisted_23
                  ]),
                  _: 1
                }))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})